<template>
  <div class="table-responsive">
    <table class="table table-sm align-middle mb-0">
      <thead>
        <tr>
          <th style="width: 36px">#</th>
          <th>Attachment</th>
          <th>Part</th>
          <th>Status</th>
          <th>Size</th>
          <th>Uploaded</th>
          <th>Completed</th>
          <th>Path</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(p, pidx) in parts" :key="p.id">
          <td class="text-muted">{{ pidx + 1 }}</td>
          <td class="font-monospace">{{ p.attachment_id }}</td>
          <td class="font-monospace">#{{ p.part_index }}</td>
          <td>
            <span :class="badgeClass(p.status)">{{ p.status }}</span>
          </td>
          <td class="font-monospace">{{ p.size }}</td>
          <td>{{ p.uploaded_at || "—" }}</td>
          <td>{{ p.completed_at || "—" }}</td>
          <td
            class="font-monospace text-truncate"
            style="max-width: 320px"
            :title="p.path || '—'"
          >
            {{ p.path || "—" }}
          </td>
        </tr>
        <tr v-if="!parts || !parts.length">
          <td colspan="8" class="text-muted">No parts</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { badgeClass } from "./utils/helpers";

export default {
  name: "ExaminationPartsTable",
  props: { parts: { type: Array, default: () => [] } },
  methods: { badgeClass },
};
</script>
